module.exports = __webpack_public_path__ + "media/images/landing-check-341307d9.svg";